<h5 class="modal-title" align="center">
    <b>Importante</b>
</h5>

<div class="py-4">
    <p align="center">Debe utilizar un nuevo ICCID para la tramitación</p>
</div>

<div class="align-items-center">
    <button class="btn btn-green btn-block" (click)="closeAll()">Continuar</button>
</div>
